module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-015c2386.png";